module.exports = __webpack_public_path__ + "static/media/LogoSolutisPadrao.2421bd09.png";